// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SuggestionCard-cls1___ed7de51238858de78af{/*!*/}.SuggestionCard-cls2__ad0e3caa425d19c26715{flex-shrink:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SuggestionCard-cls1___ed7de51238858de78af",
	"cls2": "SuggestionCard-cls2__ad0e3caa425d19c26715 SuggestionCard-cls1___ed7de51238858de78af"
};
export default ___CSS_LOADER_EXPORT___;
